<template>
    <div class="container-dash" v-show="showLayout">
        <div class="contents dashboard" style="text-align: center">
            <div class="wrap-img-nft">
                <img src="@/images/safetyadm/logo.png" class="logo-nft"/>
                <div class="btn-logout">
                    <i class="material-icons" @click="logout"> power_settings_new </i>
                </div>
            </div>

            <div class="box-btn-nft">
                <button class="btn-work" v-if="plcStatus">Working...</button>
                <button class="btn-work red" v-else>STOP</button>
                <div class="wrap-btn-nft">
                    <button class="btn-nft" @click="startServer()">START</button>
                    <button class="btn-nft red" @click="stopServer()">STOP</button>
                </div>
            </div>
            <div class="box-text-type">
                <div class="wrap-text-type">
                    <div class="title-type">투입</div>
                    <div class="text-type">{{ dashData.input }}</div>
                </div>
                <div class="wrap-text-type">
                    <div class="title-type">성공</div>
                    <div class="text-type">{{ dashData.success }}</div>
                </div>
                <div class="wrap-text-type">
                    <div class="title-type">실패</div>
                    <div class="text-type">{{ dashData.fail }}</div>
                </div>
                <div class="wrap-text-type">
                    <div class="title-type">성공률</div>
                    <div class="text-type red">{{ returnRate(dashData.success, dashData.input) }}%</div>
                </div>

            </div>
            <div class="text-warn">Writing 대기 URL이 <span>{{ dashData.waiting }}</span>개 남았습니다.</div>

            <div class="title-history">History</div>

            <div class="chart-select-common">
                <el-date-picker v-model="filterData" type="datetimerange" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" start-placeholder="시작 날짜" range-separator="~" end-placeholder="끝 날짜" @change="changeDate"/>
            </div>
            <div class="wrap-table">
                <el-table :data="historyData" style="width: 100%" empty-text="데이터가 없습니다." v-loading="historyLoading">
                    <el-table-column class="table_no" type="index" label="번호" width="200" class-name="num" :index="tableIndex"></el-table-column>
                    <el-table-column align="center" label="사유" prop="ncl_message"></el-table-column>
                    <el-table-column align="center" width="200" label="발생일">
                        <template slot-scope="scope">
                            {{ returnDateFormat(scope.row.created_at, "YYYY-MM-DD HH:mm:ss") }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="pagnation_wrap" v-show="lastPage > 0">
                <el-pagination :page-size=filterPagnation.size :pager-count=filterPagnation.pagerCount layout="prev, pager, next" :current-page.sync=page :total="listTotal" @current-change="getList"></el-pagination>
            </div>


            <div class="title-url">URL발급현황</div>

            <div class="box-nft-chart">
                <div class="chart-nft" style="position:relative;width: 150px; height: 150px" id="donut"></div>
                <div class="wrap-nft-text">
                    <div class="box-statistics-nft bold">
                        <div class="statistics-circle-nft"></div>
                        <div class="statistics-title-nft bold">발급된 URL</div>
                        <div class="statistics-text-nft bold">{{ returnCommas(totalCount) }}</div>
                    </div>
                    <div class="box-statistics-nft">
                        <div class="statistics-circle-nft orange"></div>
                        <div class="statistics-title-nft">NFC Writing 완료</div>
                        <div class="statistics-text-nft">{{ returnCommas(dashData.tagging) }} ({{ returnRate(dashData.tagging, totalCount) }}%)
                        </div>
                    </div>
                    <div class="box-statistics-nft">
                        <div class="statistics-circle-nft blue"></div>
                        <div class="statistics-title-nft">Writing 대기</div>
                        <div class="statistics-text-nft">{{ returnCommas(dashData.waiting) }} ({{ returnRate(dashData.waiting, totalCount) }}%)
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap-dash-footer">
        <page-footer></page-footer>
        </div>
    </div>
</template>

<script>

import util from "@/mixins/util";
import dateMixins from "@/mixins/dateMixins";
import * as echarts from "echarts";
import localStorage from "@/mixins/localStorage";
import VuxAlert from '@/mixins/vux-alert';

export default {
    name: "NftDashboard",
    components: {},
    mixins: [dateMixins, localStorage, VuxAlert],
    data() {
        return {
            dashData: {},
            pagnation: {
                size: 10,
                pagerCount: 11,
                page: 1,
            },
            page: 1,
            lastPage: 0,
            listTotal: 0,
            historyData: [],
            historyLoading: true,
            filterData: [],
            donutChart: null,
            totalCount: 0,
            showLayout: false,
            plcStatus: false,
            intervalIdFirst: 0,
            intervalIdTwo: 0,
        };
    },
    computed: {
        tableFilter() {
            return this.historyData
        },
        filterPagnation() {
            return {
                size: 5,
                pagerCount: 11,
                total: this.tableFilter.length,
                page: 1
            }
        }
    },
    mounted() {
    },
    
    created() {
        this.getStatus();
        this.getList();
        this.getDashBoard();
        this.intervalIdFirst = setInterval(() => {
            this.getDashBoard();
        }, 4000);
        this.intervalIdTwo = setInterval(() => {
            this.getList();
        }, 12000);
    },
    beforeDestroy() {
        clearInterval(this.intervalIdFirst)
        clearInterval(this.intervalIdTwo)
        
    },
    methods: {
        setData(key, value) {
            this[key] = value;
        },
        getDashBoard() {
            let params = {};
            // if (!util.isEmpty(this.filterData)) {
            //     params.crsd = `${this.filterData[0]}:00`;
            //     params.cred = `${this.filterData[1]}:00`;
            // }
            this.$api.$nfc.getDashBoard(params).then(res => res.Data.result).then(res => {
                if (res.Info.Type == 1) {
                    this.dashData = res.List;
                    this.showLayout = true;
                    // this.setCartData();
                }
            })
        },
        returnRate(part, total) {
            if (part == 0 && total == 0) return 0;
            return Math.floor((part / total) * 100);
        },
        async getList() {
            this.historyLoading = true;
            let params = {
                ip: 1,
                sp: 5,
                page: this.page,
            }
            if (!util.isEmpty(this.filterData)) {

                params.crsd = `${this.filterData[0]}:00`;
                params.cred = `${this.filterData[1]}:00`;
            }
            await this.$api.$nfc.getDashBoardNfcHistory(params).then(res => res.Data.result).then(res => {
                if (res.Info.Type === 1) {
                    this.historyData = res.List;
                    this.lastPage = res.Page.last_page;
                    this.listTotal = res.Page.total;
                } else {
                    this.historyData = [];
                    this.page = 1;
                    this.lastPage = 0;
                    this.listTotal = 0;
                }
            })
            this.historyLoading = false;
            this.showLayout = true;
            this.setCartData();
        },
        tableIndex(index) {
            return index + this.pagnation.size * (this.page - 1) + 1
        },
        changeDate() {
      this.page =1;
      clearInterval(this.intervalIdFirst)
      clearInterval(this.intervalIdTwo)
      this.getDashBoard();      
      this.getList();      
      this.intervalIdFirst = setInterval(() => {
        this.getDashBoard();      
      }, 4000);
      this.intervalIdTwo = setInterval(() => {
        this.getList();      
      }, 12000);
        },
        returnCommas(price) {
            if (!util.isEmpty(price)) {
                return util.Number.numFormat(price);
            } else {
                return 0;
            }
        },
        setCartData() {
            this.totalCount = this.dashData.tagging + this.dashData.waiting;
            this.chartData = [
                {
                    value: this.dashData.waiting,
                    name: "Writing 대기",
                    itemStyle: {
                        color: "blue",
                        decal: {
                            symbol: "none",
                        },
                    },
                },
                {
                    value: this.dashData.total,
                    name: "NFC Writing 완료",
                    itemStyle: {
                        color: "orange",
                        decal: {
                            symbol: "none",
                        },
                    },
                },
            ];
            this.setDonut();
        },
        setDonut() {
            let chartDom = document.getElementById("donut");
            this.donutChart = echarts.init(chartDom, null, {});
            let option = {
                tooltip: {
                    trigger: "item",
                },
                series: [
                    {
                        name: "",
                        type: "pie",
                        radius: ["40%", "70%"],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: "center",
                        },
                        labelLine: {
                            show: false,
                        },
                        data: this.chartData,
                    },
                ],
            };
            this.donutChart.clear();
            this.donutChart.setOption(option);
        },
        logout() {
            let $this = this
            this.$vux.confirm.show({
                content: '로그아웃 하시겠습니까?',
                confirmText: "확인",
                cancelText: "취소",
                onConfirm() {
                    $this.localLogout();
                }
            });
        },
        getStatus() {
            setInterval(() => {
                this.$api.$nfc.getNfcServerStatus({}).then(res => res.Data.result).then(res => {
                    if (res.Info.Type == 1) {
                        this.plcStatus = res.List.status;
                    } else {
                        this.plcStatus = false;
                    }
                })
            }, 4000);
        },
        startServer() {
            this.$api.$nfc.getNfcServerStatus({}).then(res => res.Data.result).then(res => {
                if (res.Info.Type == 1) {
                    let status = res.List.status;
                    if (status) {
                        this.showAlert("이미 실행중에 있습니다.");
                    } else {
                        this.$api.$nfc.getNfcServerKey({}).then(res => res.Data.result).then(res => {
                            if (res.Info.Type == 1) {
                                let params = {
                                    keyData: res.List
                                }
                                this.$api.$nfc.startNfcServer(params).then(res => res.Data.result).then(res => {
                                    if (res.Info.Type == 1) {
                                        this.plcStatus = true;
                                    } else {
                                        this.showAlert(res.Info.reason);
                                    }
                                })
                            } else {
                                this.showAlert(res.Info.reason);
                            }
                        })
                    }
                } else {
                    this.plcStatus = false;
                    this.createAlert({
                        title: "",
                        content: "에러 발생, 잠시후 실행해주세요.",
                        btnText: "확인"
                    });
                }
            })
        },
        stopServer() {
            this.$api.$nfc.stopNfcServer({}).then(res => res.Data.result).then(res => {
                if (res.Info.Type == 1) {
                    this.plcStatus = false;
                    this.showAlert(res.Info.reason);
                } else {
                    this.showAlert(res.Info.reason);
                }
            })
        },
        showAlert(msg) {
            this.createAlert({
                title: "",
                content: msg == "" ? "에러 발생, 잠시후 실행해주세요." : msg,
                btnText: "확인"
            });
        }
    },
};
</script>
<style>
.chart-select-common .el-range-editor {

    width: 330px !important;
    padding-right: 10px !important;
}


</style>
